<div>
  <div class="row mb-3">
    <div class="col-sm-6">
      <button type="button" class="btn btn-primary" (click)="back()">
        <span>Back</span>
      </button>
    </div>
    <div class="col-sm-6 d-flex justify-content-end">
      <!-- <button type="button" class="btn btn-primary mr-2" (click)="downloadDrawings()">
        <span *ngIf="!downloadPurchaseQuoteDrawLoading">Download Drawings</span>
        <span *ngIf="downloadPurchaseQuoteDrawLoading"
          ><i class="fa fa-spinner fa-spin"></i> Downloading</span
        >
      </button> -->
      <button type="button" class="btn btn-primary" (click)="download()">
        <span *ngIf="!downloadPurchaseQuoteLoading">Download</span>
        <span *ngIf="downloadPurchaseQuoteLoading"
          ><i class="fa fa-spinner fa-spin"></i> Downloading</span
        >
      </button>
    </div>
  </div>
  <div class="card">
    <div class="row">
      <div class="col-md-12">
        <img
          src="./assets/icons/bluelogo.png"
          height="60"
          class="mb-3"
          alt="Kwikspace"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 col-sm-12 ml-2">
        <h5 class="title-heading">Purchase Quotation</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-5 col-sm-12">
        <div class="row">
          <div class="col-md-6 col-sm-6">
            <strong>Company</strong>
          </div>
          <div class="col-md-6 col-sm-6">
            {{ quote.customer.company.name }}
          </div>
        </div>
        <div class="row d-flex justify-content-end">
          <div class="col-md-6 col-sm-6">
            <strong>Attention</strong>
          </div>
          <div class="col-md-6 col-sm-6">
            {{ quote.customer.firstName }}
          </div>
        </div>
        <div class="row d-flex justify-content-end">
          <div class="col-md-6 col-sm-6">
            <strong>Contact No</strong>
          </div>
          <div class="col-md-6 col-sm-6">
            {{ quote.customer.company.contactNumber }}
          </div>
        </div>
        <div class="row d-flex justify-content-end">
          <div class="col-md-6 col-sm-6">
            <strong>Cell No</strong>
          </div>
          <div class="col-md-6 col-sm-6">
            {{ quote.customer.company.cellNumber }}
          </div>
        </div>
        <div class="row d-flex justify-content-end">
          <div class="col-md-6 col-sm-6">
            <strong>Email</strong>
          </div>
          <div class="col-md-6 col-sm-6">
            {{ quote.customer.email }}
          </div>
        </div>
        <!-- <div class="row d-flex justify-content-end" *ngIf="quote.lineItems.length > 0">
					<div class="col-md-6 col-sm-6">
						<strong>Delivery Period</strong>
					</div>
					<div class="col-md-6 col-sm-6">
						{{ quote.requiredBy }}
					</div>
				</div> -->
      </div>
      <div class="col-md-5 col-sm-12">
        <div class="row">
          <div class="col-md-6 col-sm-6">
            <strong>Date</strong>
          </div>
          <div class="col-md-6 col-sm-6">
            {{ quote.createdDate | date: "mediumDate" }}
          </div>
        </div>
        <div class="row d-flex justify-content-end">
          <div class="col-md-6 col-sm-6">
            <strong>From</strong>
          </div>
          <div class="col-md-6 col-sm-6">
            {{ quote.quoteOwner.user.firstName }}
            {{ quote.quoteOwner.user.lastName }}
          </div>
        </div>
        <div class="row d-flex justify-content-end">
          <div class="col-md-6 col-sm-6">
            <strong>Our Reference</strong>
          </div>
          <div class="col-md-6 col-sm-6">
            {{ quote.quoteNumber }}
          </div>
        </div>
        <div class="row d-flex justify-content-end">
          <div class="col-md-6 col-sm-6">
            <strong>Delivery Period</strong>
          </div>
          <div class="col-md-6 col-sm-6">
            {{ quote.requiredBy }}
          </div>
        </div>
        <div class="row d-flex justify-content-end">
          <div class="col-md-6 col-sm-6">
            <strong>Your Reference</strong>
          </div>
          <div class="col-md-6 col-sm-6">
            {{ quote.yourReference }}
          </div>
        </div>
      </div>
    </div>
    <hr class="ml-2 mr-2" size="10" noshade />
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <p class="ml-2">
          Dear Sir/Madam <br />
          We take pleasure in submitting our official quotation for supply and
          delivery of Prefabricated Building(s) for your consideration as
          follows:
        </p>
      </div>
    </div>

    <ng-container *ngIf="quote.purchaseLineItems.length > 0">
      <div class="row ml-2 mr-2 col-heading">
        <div class="col-sm-1">No.</div>
        <div class="col-sm-3">Description</div>
        <div class="col-sm-1 d-flex justify-content-center">Drawing No</div>
        <div class="col-sm-2 d-flex justify-content-center">Unit Size</div>
        <div class="col-sm-1 d-flex justify-content-center">QTY</div>
        <div class="col-sm-2 d-flex justify-content-center">Unit Price</div>
        <div class="col-sm-2 d-flex justify-content-center">Total Price</div>
      </div>

      <ng-container *ngFor="let item of quote.purchaseLineItems">
        <div class="row ml-2 mr-2">
          <div class="col-sm-12">
            {{ item.unit }}
          </div>
        </div>

        <div class="row ml-2 mr-2">
          <div class="col-sm-1">
            <button
              type="button"
              class="btn drawing-btn"
              (click)="view3d(item)"
            >
              3d
            </button>
            <button
              type="button"
              class="btn drawing-btn ml-2"
              (click)="view2d(item)"
            >
              2d
            </button>
          </div>
          <div class="col-sm-3">
            {{ item.name }}
          </div>
          <div class="col-sm-1 text-center">
            <span class="drawing-no" (click)="viewDrawing(item.drawingNo)">{{ item.drawingNo }}</span>
          </div>
          <div class="col-sm-2 text-center">
            {{ item.unitSize }}
          </div>
          <div class="col-sm-1 text-center">
            {{ item.quantity }}
          </div>
          <div class="col-sm-2 text-right">
            {{ item.unitPrice | currency: "ZAR" : "R " }}
          </div>
          <div class="col-sm-2 text-right">
            {{ item.totalPrice | currency: "ZAR" : "R " }}
          </div>
        </div>
        <!-- <div class="row ml-2 mr-2"  *ngFor="let lineItem of item.purchaseAssetItemConfigurations">
					<div class="col-sm-1"></div>
					<div class="col-sm-3">
						{{ lineItem.name }}
					</div>
					<div class="col-sm-1 text-center">
						{{ lineItem.drawingNo }}
					</div>
					<div class="col-sm-2 text-center">
						{{ lineItem.unitSize }}
					</div>
					<div class="col-sm-1 text-center">
						{{ lineItem.quantity }}
					</div>
					<div class="col-sm-2 text-right">
						{{ lineItem.unitPrice | currency:'ZAR':'R ' }}
					</div>
					<div class="col-sm-2 text-right">
						{{ lineItem.totalPrice | currency:'ZAR':'R ' }}
					</div>
				</div> -->

        <!-- Delivery price rows -->
        <div
          class="row ml-2 mr-2 item-row mt-2 pb-2"
          *ngIf="item.deliveryCharge"
        >
          <div class="col-sm-1"></div>
          <div class="col-sm-3">
            {{ item.deliveryCharge.transportCharge.name }} -
            {{ item.deliveryCharge.transportLocation.district.name }} -
            {{ item.deliveryCharge.transportLocation.name }}
          </div>
          <div class="col-sm-1"></div>
          <div class="col-sm-2"></div>
          <div class="col-sm-1 text-center">{{ item.deliveryChargeQty }}</div>
          <div class="col-sm-2 text-right">
            {{ item.deliveryCharge.price | currency: "ZAR" : "R " }}
          </div>
          <div class="col-sm-2 text-right">
            {{
              item.deliveryCharge.totalDeliveryPrice | currency: "ZAR" : "R "
            }}
          </div>
        </div>

        <!-- Joining price rows -->
        <div
          class="row ml-2 mr-2 item-row mt-2 pb-2"
          *ngIf="item.deliveryChargeOptional"
        >
          <div class="col-sm-1"></div>
          <div class="col-sm-3">
            {{ item.deliveryChargeOptional.transportCharge.name }} -
            {{ item.deliveryChargeOptional.transportLocation.district.name }} -
            {{ item.deliveryChargeOptional.transportLocation.name }}
          </div>
          <div class="col-sm-1"></div>
          <div class="col-sm-2"></div>
          <div class="col-sm-1 text-center">{{ item.quantity }}</div>
          <div class="col-sm-2 text-right">
            {{ item.deliveryChargeOptional.price | currency: "ZAR" : "R " }}
          </div>
          <div class="col-sm-2 text-right">
            {{ item.deliveryChargeOptional.price | currency: "ZAR" : "R " }}
          </div>
        </div>
      </ng-container>
      <!-- sub total row -->
      <div class="row ml-2 mr-2">
        <div class="col-sm-8"></div>
        <div class="col-sm-2 row-border">Sub Total</div>
        <div class="col-sm-2 text-right row-border">
          {{ initSubTotal | currency: "ZAR" : "R " }}
        </div>
      </div>
      <div class="row ml-2 mr-2">
        <div class="col-sm-8"></div>
        <div class="col-sm-2 row-border">VAT</div>
        <div class="col-sm-2 text-right row-border">
          {{ initVat | currency: "ZAR" : "R " }}
        </div>
      </div>
      <div class="row ml-2 mr-2">
        <div class="col-sm-8"></div>
        <div class="col-sm-2 row-border">Total Due (ZAR)</div>
        <div class="col-sm-2 text-right row-border">
          {{ initTotal | currency: "ZAR" : "R " }}
        </div>
      </div>
    </ng-container>

    <hr class="ml-2 mr-2" size="10" noshade />

    <div class="row mt-2 mb-2 mr-0">
      <div class="ml-2 col-sm-12">
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <span>Sales consultant</span>
          </div>
          <div class="col-md-4 col-sm-6">
            <span
              >{{ quote.quoteOwner.user.firstName }}
              {{ quote.quoteOwner.user.lastName }}</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <span>Email</span>
          </div>
          <div class="col-md-4 col-sm-6">
            <span>{{ quote.quoteOwner.user.email }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <span>Tel</span>
          </div>
          <div class="col-md-4 col-sm-6">
            <span>011 617 8000</span>
          </div>
        </div>
      </div>
    </div>

    <hr class="ml-2 mr-2" size="10" noshade />

    <div class="row mt-2 mb-2 mr-0">
      <div class="col-sm-12">
        <p class="ml-2">
          Please Note: The transport price has been provided as an estimate.
        </p>
        <p class="ml-2">
          Please contact a Kwikspace representative for discounted rates, where
          units can be placed on combined truck sizes.
        </p>
      </div>
    </div>

    <hr class="ml-2 mr-2" size="10" noshade />

    <div class="row mt-2 mb-2 mr-0">
      <div class="col-sm-12">
        <p class="ml-2">
          The installation of air conditioners is excluded and can be provided
          by your account manager on request.
        </p>
      </div>
    </div>

    <ng-container>
      <hr class="ml-2 mr-2" size="10" noshade />

      <div class="row mt-2 mb-2 mr-0">
        <div class="col-sm-12">
          <p class="ml-2">
            Prices exclude Medical, Induction, Safety File, Tool tagging
          </p>
          <p class="ml-2">and any required Covid Testing.</p>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isStaff && quote.notes != ''">
      <hr class="ml-2 mr-2" size="10" noshade />

      <div class="row mt-2 mr-0">
        <div class="ml-2 col-sm-12">
          <span><b>Notes:</b></span>
        </div>
      </div>
      <div class="row mt-2 mb-2 mr-0">
        <div class="ml-2 col-sm-12">
          <span>{{ quote.notes }}</span>
        </div>
      </div>
    </ng-container>

    <hr class="ml-2 mr-2" size="10" noshade />

    <div class="row mt-2 mb-2 mr-0 ml-0">
      <div class="col-sm-12 accordion-wrapper">
        <div class="row mt-2 mb-2 mr-0 ml-0">
          <div class="col-sm-12 accordion-wrapper">
            <h4 class="d-flex justify-content-center">
              <u>Order Processing</u>
            </h4>
            <div class="mt-3 mb-3">
              <p class="mb-0">
                a. Please note that should the attached quote be accepted,
                Kwikspace will only commit to a delivery and/or collection date
                once all required documentation is provided. As an ISO certified
                entity it is imperative to have all required documentation to
                process your order.
              </p>
              <p class="mb-0">
                b. Your official order date will be considered the date in which
                the last final documentation has been provided and not the date
                the order has been submitted.
              </p>
              <p>
                c. Kwikspace banking details: <br />
                <span>
                  <div class="row ml-3">
                    <div class="col-md-2 col-sm-6">Bank Name</div>
                    <div class="col-md-10 col-sm-6">
                      : Nedbank Business Banking
                    </div>
                  </div>
                  <div class="row ml-3">
                    <div class="col-md-2 col-sm-6">Branch Code</div>
                    <div class="col-md-10 col-sm-6">: 198765</div>
                  </div>
                  <div class="row ml-3">
                    <div class="col-md-2 col-sm-6">Branch</div>
                    <div class="col-md-10 col-sm-6">
                      : Nedbank Business Banking Eastern Gauteng
                    </div>
                  </div>
                  <div class="row ml-3">
                    <div class="col-md-2 col-sm-6">Account Number</div>
                    <div class="col-md-10 col-sm-6">: 1288117132</div>
                  </div>
                  <div class="row ml-3">
                    <div class="col-md-2 col-sm-6">Account Type</div>
                    <div class="col-md-10 col-sm-6">: Cheque</div>
                  </div>
                  <div class="row ml-3">
                    <div class="col-md-2 col-sm-6">Account Holder</div>
                    <div class="col-md-10 col-sm-6">
                      : Kwikspace Modular Buildings (Pty) Ltd
                    </div>
                  </div>
                </span>
              </p>
              <p>
                d. To ensure your order is processed, please ensure the
                following information is provided by completing the below:<br />
                <span>
                  <div class="row ml-3 mt-2">
                    <div class="col-md-12 col-sm-12">
                      1. All pages of our quote including Terms and Conditions
                      to be signed
                    </div>
                  </div>
                  <div class="row ml-3">
                    <div class="col-md-2 col-sm-6">
                      2. Site contact person (1) Name
                    </div>
                    <div class="col-md-8 col-sm-6" id="signature">:</div>
                  </div>
                  <div class="row ml-3">
                    <div class="col-md-2 col-sm-6">
                      3. Site contact person (1) Cell #
                    </div>
                    <div class="col-md-8 col-sm-6" id="signature">:</div>
                  </div>
                  <div class="row ml-3">
                    <div class="col-md-2 col-sm-6">
                      4. Site contact person (2) Name
                    </div>
                    <div class="col-md-8 col-sm-6" id="signature">:</div>
                  </div>
                  <div class="row ml-3">
                    <div class="col-md-2 col-sm-6">
                      5. Site contact person (2) Cell #
                    </div>
                    <div class="col-md-8 col-sm-6" id="signature">:</div>
                  </div>
                  <div class="row ml-3">
                    <div class="col-md-2 col-sm-6">
                      6. Accounts contact person Name
                    </div>
                    <div class="col-md-8 col-sm-6" id="signature">:</div>
                  </div>
                  <div class="row ml-3">
                    <div class="col-md-2 col-sm-6">
                      7. Accounts contact person Cell #
                    </div>
                    <div class="col-md-8 col-sm-6" id="signature">:</div>
                  </div>
                  <div class="row ml-3">
                    <div class="col-md-2 col-sm-6">
                      8. Full delivery Address
                    </div>
                    <div class="col-md-8 col-sm-6" id="signature">:</div>
                  </div>
                  <div class="row ml-3">
                    <div class="col-md-2 col-sm-6"></div>
                    <div class="col-md-8 col-sm-6" id="signatureAddress"></div>
                  </div>
                  <div class="row ml-3 mt-2">
                    <div class="col-md-3 col-sm-6">
                      9. GPS co-ordinates of site if address is not available
                    </div>
                    <div class="col-md-7 col-sm-6" id="signature"></div>
                  </div>
                </span>
              </p>
              <p class="mt-2">
                e. Confirmation of Additional Requirements,
                <mark class="red"
                  ><strong
                    >if not quoted, a quote will be provided</strong
                  ></mark
                >. <br />
                <span>
                  <table border="1px">
                    <thead>
                      <th>Description</th>
                      <th colspan="2">Tick where applicable</th>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Official Purchase included ?</td>
                        <td>Yes <input type="checkbox" /></td>
                        <td><input type="checkbox" /> No</td>
                      </tr>
                      <tr>
                        <td>Signed off drawings included ?</td>
                        <td>Yes <input type="checkbox" /></td>
                        <td><input type="checkbox" /> No</td>
                      </tr>
                      <tr>
                        <td>
                          Proof of 50% payment (for non account holders)
                          included ?
                        </td>
                        <td>Yes <input type="checkbox" /></td>
                        <td><input type="checkbox" /> No</td>
                      </tr>
                      <tr>
                        <td>
                          Safety File (If yes, additional information may be
                          required)
                        </td>
                        <td>Yes <input type="checkbox" /></td>
                        <td><input type="checkbox" /> No</td>
                      </tr>
                      <tr>
                        <td>
                          If full/site specific Safety File is required:
                          <br />
                          <span
                            >- Is there a requirement for Induction? If so, how
                            many days & cost involved?</span
                          ><br />
                          <div class="row">
                            <div class="col-md-2 col-sm-6 ml-2">
                              Days / Costs / Comments:
                            </div>
                            <div
                              class="col-md-6 col-sm-6 mb-2"
                              id="signature"
                            ></div>
                          </div>
                          <span
                            >- Are special Medicals required? If yes, can you
                            please confirm if there is a cost</span
                          ><br />
                          <div class="row">
                            <div class="col-md-2 col-sm-6 ml-2">
                              Costs / Comments:
                            </div>
                            <div
                              class="col-md-6 col-sm-6 mr-5 mb-2"
                              id="signature"
                            ></div>
                          </div>
                          <span>
                            - Does the company require registration to a
                            special, online SHEQ Management System during the
                            course of the project? If so, please advise all
                            costs related to the system.
                          </span>
                          <br />
                          <div class="row">
                            <div class="col-md-2 col-sm-6 ml-2">
                              Costs / Comments:
                            </div>
                            <div
                              class="col-md-6 col-sm-6 mr-5 mb-2"
                              id="signature"
                            ></div>
                          </div>
                        </td>
                        <td>
                          Yes <input type="checkbox" /> <br />
                          <br />
                          Yes <input type="checkbox" /> <br />
                          <br />
                          Yes <input type="checkbox" />
                        </td>
                        <td>
                          <input type="checkbox" /> No<br />
                          <br />
                          <input type="checkbox" /> No<br />
                          <br />
                          <input type="checkbox" /> No
                        </td>
                      </tr>
                      <tr>
                        <td>Tool Tagging</td>
                        <td>Yes <input type="checkbox" /></td>
                        <td><input type="checkbox" /> No</td>
                      </tr>
                      <tr>
                        <td>Medical</td>
                        <td>Yes <input type="checkbox" /></td>
                        <td><input type="checkbox" /> No</td>
                      </tr>
                      <tr>
                        <td>Inductions</td>
                        <td>Yes <input type="checkbox" /></td>
                        <td><input type="checkbox" /> No</td>
                      </tr>
                      <tr>
                        <td>Spreader Beams / Cranes</td>
                        <td>Yes <input type="checkbox" /></td>
                        <td><input type="checkbox" /> No</td>
                      </tr>
                      <tr>
                        <td>
                          Installation of Window Wall Airconditioners is
                          excluded,if required quote will be amended
                        </td>
                        <td>Yes <input type="checkbox" /></td>
                        <td><input type="checkbox" /> No</td>
                      </tr>
                      <tr>
                        <td>Site visit required for delivery of unit/move</td>
                        <td>Yes <input type="checkbox" /></td>
                        <td><input type="checkbox" /> No</td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </p>
              <p>
                f. Please provide us with any special instructions you require
                to be noted during your order process: <br />
                <span>
                  <table border="1px">
                    <tbody>
                      <tr height="25px">
                        <td></td>
                      </tr>
                      <tr height="25px">
                        <td></td>
                      </tr>
                      <tr height="25px">
                        <td></td>
                      </tr>
                      <tr height="25px">
                        <td></td>
                      </tr>
                      <tr height="25px">
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </p>
              <p>
                <span>
                  <div class="row">
                    <div class="col-md-10 col-sm-8">
                      g. Do you have any specific delivery instructions?
                    </div>
                    <div class="col-md-1 col-sm-2">
                      Yes <input type="checkbox" />
                    </div>
                    <div class="col-md-1 col-sm-2">
                      <input type="checkbox" /> No
                    </div>
                  </div>
                </span>
                <span>
                  <div class="ml-3">
                    If yes, please elaborate on the process as well as the
                    authorised representative to receive your stock.
                  </div>
                </span>
                <span>
                  <table border="1px">
                    <tbody>
                      <tr height="25px">
                        <td></td>
                      </tr>
                      <tr height="25px">
                        <td></td>
                      </tr>
                      <tr height="25px">
                        <td></td>
                      </tr>
                      <tr height="25px">
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </span>
              </p>
              <p>
                h. Delivery Checklist:
                <span>
                  <table border="1px">
                    <tr>
                      <th rowspan="7">1</th>
                      <th>Is the delivery site accessible?</th>
                      <th>Yes</th>
                      <th>No</th>
                      <th>N/A</th>
                    </tr>
                    <tr>
                      <td>
                        - The entrance must be at least 4m wide for a 3m wide
                        unit, and 4.5m for wider units
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>- Are there overhanging branches?</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        - Are there any overhead obstructions lower than 4,7m
                        above the ground?
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        - The truck will reverse into position - is there enough
                        space?
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        - Are there any poles, bushes, trees, fences, walls,
                        other vehicles or any obstruction?
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr class="borderBottom">
                      <td>
                        - Once the unit has been offloaded, the driver requires
                        an unobstructed distance of 7m, plus the equivalent
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <th rowspan="6">2</th>
                      <th>Is the delivery site accessible?</th>
                      <th>Yes</th>
                      <th>No</th>
                      <th>N/A</th>
                    </tr>
                    <tr>
                      <td>
                        - Please confirm that the ground where the unit/s will
                        be positioned will be level. (If your site is not level,
                        we may require additional concrete blocks, and this will
                        be charged to the client. The site should not slope more
                        than 200mm over the area of the building.)
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        - Please confirm that the ground conditions are, or will
                        be, firm and compact enough to withstand possible
                        penetration of the jacks when supporting the weight of
                        the unit
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        - Please confirm that there are no rocks, bricks, glass
                        etc. in the surrounding area
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        - Please note - the vehicles cannot drive onto
                        waterlogged grass or mud, the vehicles will get stuck.
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr class="borderBottom">
                      <td>
                        - Please note - we cannot lodd/offload while it is
                        raining or in poor conditions (strong winds, storms) or
                        when visibility is poor
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </table>
                </span>
              </p>
            </div>
            <h6><strong>3. Important Notes</strong></h6>
            <div class="mt-3 mb-5">
              <p class="ml-3">- The unit is manually loaded and offloaded.</p>
              <p class="ml-3">
                - It is the customer's responsibility to ensure that the unit is
                in the correct place and in the correct position, i.e. Doors
                facing the right way, before the unit is offloaded. Additional
                moves on site will be charged for.
              </p>
              <p class="ml-3">
                - We do not use a crane, unless prior arrangements have been
                made with the client and the use of a crane has been quoted for.
              </p>
              <p class="ml-3">
                - Units standing on a solid concrete plinth/slab exceeding 200mm
                cannot be loaded manually as the vehicle has to be able to
                reverse under the unit.
              </p>
              <p class="ml-3">
                - The jacking equipment requires a clear space of at least1m on
                all four corners of the unit.
              </p>
              <p class="ml-3">
                - Please be advised that all single wide units up to 12m long
                are placed on jacks and concrete pads. The gap between the
                ground and entrance of the unit is approximately 250mm.
              </p>
              <p class="ml-3">
                - Single Wide Units and all Double Wide Units are placed on
                tripod jacks. The gap between the ground and entrance of the
                unit is approximately 400mm. Please note this may vary based on
                how level your site is. Access to the units will be with a steel
                step. Please advise your accounts manager before we deliver if
                you would like any changes to be made to the above as changes
                not communicated before delivery will be charged for.
              </p>
              <br />
              <span>
                <div class="row ml-3 mt-2">
                  <div class="col-md-12 col-sm-12">
                    I, the undersigned, hereby confirm the information provided
                    above is true and accept Kwikspace standard commercial
                    terms.
                  </div>
                </div>
                <div class="row ml-3">
                  <div class="col-md-2 col-sm-6">Company Name (in print)</div>
                  <div class="col-md-8 col-sm-6" id="signature">:</div>
                </div>
                <div class="row ml-3">
                  <div class="col-md-2 col-sm-6">
                    Approved by (name & surname)
                  </div>
                  <div class="col-md-8 col-sm-6" id="signature">:</div>
                </div>
                <div class="row ml-3">
                  <div class="col-md-2 col-sm-6">Designation</div>
                  <div class="col-md-8 col-sm-6" id="signature">:</div>
                </div>
                <div class="row ml-3">
                  <div class="col-md-2 col-sm-6">Signature</div>
                  <div class="col-md-8 col-sm-6" id="signature">:</div>
                </div>
                <div class="row ml-3">
                  <div class="col-md-2 col-sm-6">Date</div>
                  <div class="col-md-8 col-sm-6" id="signature">:</div>
                </div>
                <div class="row ml-3">
                  <div class="col-md-2 col-sm-6">
                    Witnessed by (name & surname)
                  </div>
                  <div class="col-md-8 col-sm-6" id="signature">:</div>
                </div>
                <div class="row ml-3">
                  <div class="col-md-2 col-sm-6">Signature</div>
                  <div class="col-md-8 col-sm-6" id="signature">:</div>
                </div>
                <div class="row ml-3">
                  <div class="col-md-2 col-sm-6">Date</div>
                  <div class="col-md-8 col-sm-6" id="signatureAddress"></div>
                </div>
              </span>
            </div>

            <h4 class="d-flex justify-content-center">
              <u>Standard Commercial Terms</u>
            </h4>
            <ngb-accordion>
              <ngb-panel id="static-2">
                <ng-template ngbPanelTitle>
                  <span>Price</span>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    a. The amount quoted in our quotation is exclusive of Vat
                    and, where the quotation is made to companies or entities
                    outside South Africa, the quotation excludes allowance for
                    customs, duties, clearing charges and with-holding Tax.
                  </p>

                  <p>
                    b. The quotation is open for acceptance for a period of
                    thirty(30) calendar days from date thereof, unless otherwise
                    stated.
                  </p>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="static-3">
                <ng-template ngbPanelTitle>
                  <span>Payment</span>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    a. Initial advance payment/deposit of 50% with the balance
                    payable prior to dispatch / collection
                  </p>
                  <p>
                    b. Non standard or customised client specific builing/s will
                    require a 80% deposit payment and balance payable prior to
                    dispatch/ collection
                  </p>
                  <p>
                    c. We reserve the right to invoice for payment upon
                    completion of manufactured units, in the event that the site
                    may not be ready for delivery and/or collection
                  </p>
                  <p>
                    d. Due to the current economic impact following the world
                    wide pandemic, Kwikspace are unable to grant credit
                    facilities and 100% must be paid prior to goods leaving the
                    yard.
                  </p>
                  <p>e. 3% Interest will be charged on all overdue accounts.</p>
                  <p>
                    f. All account holders are subject to the company’s credit
                    limit policy.
                  </p>
                  <p>
                    g. Ownership of all materials and goods supplied by us,
                    remains vested in us until the quoted price together with
                    any additional costs, if applicable, has been paid in full.
                  </p>
                  <p>
                    h. We reserve the right to exercise our lien on such
                    materials in the event that payment is not made in
                    accordance with these standard commercial terms.
                  </p>
                  <p>
                    i. We reserve the right to to charge R5/m² per day for
                    storage, on unit/s not collected or ready for delivery.
                  </p>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="static-5">
                <ng-template ngbPanelTitle>
                  <span>Delivery Period</span>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>Delivery as specified in our official quotation</p>
                  <p class="mb-1">This period is subject to the following:</p>
                  <ol>
                    <li>Receipt of official purchase order</li>
                    <li>Proof of payment</li>
                    <li>signed-off drawing's authorising the manufacture</li>
                    <li>
                      Our existing commitments at the time of receipt of order.
                    </li>
                  </ol>
                  <p>
                    While we shall make every effort to complete on or within
                    the above period, we record that delays may be incurred that
                    are beyond our control. The purchaser shall not be entitled
                    to claim cancellation of the sale by reason of late
                    delivery, nor shall the purchaser be entitled to claim
                    damages or penalties whether direct or consequential by
                    reason of late delivery
                  </p>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="static-7">
                <ng-template ngbPanelTitle>
                  <span>Transportation</span>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    a. The transportation prices are based on current fuel
                    prices. We do however, reserve the right to adjust and/or
                    re-negotiate any quoted transport price as they are subject
                    to statutory fuel price increases
                  </p>
                  <p>
                    b. Standing time will be charged by the transporter at a
                    rate of R4, 950.00 per load/day should to the site not be
                    acceptable for offloading purposes as stated in clause5
                    below.
                  </p>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="static-9">
                <ng-template ngbPanelTitle>
                  <span>Positioning and Site Requirements</span>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    a. The site is required to be level with a slope not
                    exceeding more than200mm over the full length of each
                    building
                  </p>
                  <p>
                    b. Our offer is based on the assumption that the ground
                    conditions are firm and compact enough to withstand possible
                    penetration of the jacks when supporting the weight of the
                    unit. The minimum required bearing capacity is 50Mpa.
                  </p>
                  <p>
                    c. Unrestricted access for a truck and trailer, minimum
                    entrance and height requirement is 4,5 meters.
                  </p>
                  <p>
                    d. The jacking equipment requires clear space of at least 1m
                    on all four corners of the unit for the offloading.
                  </p>
                  <p>
                    e. Should the above requirements not be evident at the time
                    of delivery we reserve the right to negotiate additional
                    charges that may be required.
                  </p>
                  <p>
                    f. Should the client require exterior skirting and/or close
                    the gap from ground to the base of unit, it is imperative to
                    allow for ventilation of airflow through the unit (through
                    the use of airbricks and/or perforated finishes). Any
                    warranty claim for warping or damage caused to the flooring
                    structure due to negligence for insufficient ventilation,
                    Kwikspace will not accept liability and costs of call out
                    fee and repair will be for the clients account.
                  </p>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="static-12">
                <ng-template ngbPanelTitle>
                  <span
                    >Exclusions (Unless specifically included in our
                    quotation)</span
                  >
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    a. The design, supply and construction of all civil work
                    such as site clearance, bulk earthworks, concrete work and
                    any brickwork and roadworks/paving.
                  </p>
                  <p></p>
                  <p>
                    b. The design, supply and installation of all external
                    electrical reticulation up to the distribution board located
                    inside the building.
                  </p>
                  <p>
                    c. The design, supply and installation of all external water
                    reticulation up to the external face of the building.
                  </p>
                  <p>
                    d. The design, supply and installation of all external sewer
                    reticulation up to the external face of the building.
                  </p>
                  <p>
                    e. Design, supply and installation of external lighting.
                  </p>
                  <p>
                    f. Design, supply and installation of internal and external
                    telephone and data cables
                  </p>
                  <p>
                    g. Design, supply and installation of lightning protection
                  </p>
                  <p>
                    Design and execution of site clearing, including removal of
                    trees and other vegetation.
                  </p>
                  <p>
                    h. Design, supply and installation of fire extinguishers,
                    equipment, sprinklers and signage thereof.
                  </p>
                  <p>i. Fitment of air-conditioners.</p>
                  <p>
                    j. Design, supply and installation of furniture and
                    equipment
                  </p>
                  <p>k. Rigging of the unit/s into place</p>
                  <p>
                    l. Any municipal, local authority or similar compliance
                    requirements and approvals shall be secured by the purchaser
                    in good time prior to any delivery or installation work
                    being commenced by us.
                  </p>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="static-13">
                <ng-template ngbPanelTitle>
                  <span>Warranty</span>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    a. All materials supplied and workmanship carried out by us
                    is guaranteed for a period of twelve (12) months after
                    installation or completion of manufacture, whichever is the
                    earlier.
                  </p>
                  <p>
                    b. Our liability under this guarantee is limited to the
                    replacement or repair of any parts which are found to be
                    defective by reason of faulty raw materials supplied or
                    workmanship executed by us and excludes, without limitation,
                    glass and glazing.
                  </p>
                  <p>
                    c. The warranty on all equipment and appliances such as
                    geysers, air conditioners, stoves, extractor fans etc. shall
                    be carried by the original manufacturer and is ceded to the
                    purchaser
                  </p>
                  <p>
                    d. This guarantee excludes fair wear and tear, maintenance
                    work and other repairs required in the normal course.
                  </p>
                  <p>
                    e. The Company reserves the right to change the technical
                    data and/or specification of the Goods either to comply with
                    any applicable safety or statutory requirements or which do
                    not materially affect the quality or performance of the
                    Goods or where alternative stock is procured due to stock
                    shortages
                  </p>
                  <p>
                    f. The Warranty is applicable to goods sold and delivered in
                    South Africa.
                  </p>
                  <p>g. The Warranty does not cover:</p>
                  <ol>
                    <li>
                      Non-defective damage caused by unreasonable use,
                      vandalization, theft, fire, including use not in complete
                      accordance with goods installation manual and/or general
                      maintenance; or
                    </li>
                    <li>
                      Labour charges for the removal or re-installation of
                      replaced Goods; or
                    </li>
                    <li>
                      Transport costs incurred in transporting the Goods to
                      Customer; or
                    </li>
                    <li>Damage caused by incorrect installation; or</li>
                    <li>Goods which have been modified by Customer.</li>
                  </ol>
                </ng-template>
              </ngb-panel>

              <ngb-panel id="static-14">
                <ng-template ngbPanelTitle>
                  <span>Risk</span>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    a. Unless reduced in writing and signed by both parties, it
                    is agreed that when the unit/s have manufactured and are
                    ready for delivery, the seller will invoice the unit/s to
                    the purchaser and from the date of such invoice, the risk of
                    the unit/s will pass to the purchaser who shall remain
                    liable to pay the full purchase price despite any damage to
                    or depreciation, loss or destruction of the unit/s from
                    whatsoever cause arising
                  </p>
                  <p>
                    b. Our liability for any indirect or consequential loss or
                    damage, of whatsoever nature, is expressly excluded from
                    this quotation
                  </p>
                  <p>
                    c. We do not accept any responsibility or liability
                    whatsoever for delays due to acts of war, riot, strikes,
                    labour disputes, accidents, inclement weather, breakdown of
                    machinery, shortages of raw material, transport delays,
                    customs clearance and other disruptions caused by the
                    purchaser or any other causes of whatsoever nature beyond
                    our reasonable control.
                  </p>
                </ng-template>
              </ngb-panel>
              <ngb-panel id="static-14">
                <ng-template ngbPanelTitle>
                  <span>Cancellation</span>
                </ng-template>
                <ng-template ngbPanelContent>
                  <p>
                    a. Kwikspace will accept in writing, order changes or
                    cancellations within 24 hours of order placement.
                    Cancellations after 24 hours are subject to a cancellation
                    fee of50% of the order value, any cancellation of unit/s on
                    the manufacturing line, will not be accepted and the buyer
                    will be liable to pay the full purchase order amount
                  </p>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
